import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Authenticator extends PureComponent {
  render() {
    return (
      <div className="row" id="authenticator">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Authenticator</h2>
              <p>
                The authenticator APU allows you to test a user’s credentials against Nexoid’s Authentication engine. To use the authenticator function the current user needs the “System – Authenticator” (AUTH) permission.
              </p>

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Authentication Authenticator Example</h2>
              <p>
                This example tests the username credentials{" "}
                <strong>bob</strong> and password <strong>password123</strong>.
              </p>
              <p>Example Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/authentication/authenticator
                <div>
                  <br />
                </div>
                <div>Request Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"username"</span>:{" "}
                  <span className="jsonY">"bob"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"password"</span>:{" "}
                  <span className="jsonY">"password123"</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Example Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Response Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"username"</span>:{" "}
                  <span className="jsonY">"bob"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"authenticated"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"disabled"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div> &#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Authenticator;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Authenticator.js